module.exports = __webpack_public_path__ + "static/img/shujijieshao.75be231.png";


//////////////////
// WEBPACK FOOTER
// ./static/goumai/shujijieshao.png
// module id = Frla
// module chunks = 14